import type { RegistryEntry } from '../types';

// Grok Imagine 系列
export const grokConfigs: Record<string, RegistryEntry> = {
    'grok-imagine': {
        options: [
            {
                key: 'mode',
                label: 'Mode',
                type: 'select',
                options: [
                    { label: 'Fun', value: 'fun' },
                    { label: 'Normal', value: 'normal' },
                    // { label: 'Spicy', value: 'spicy' },
                ],
                default: 'normal',
                group: 'advanced',
            },
        ],
        toProviderOptions: (ui) => ({
            kie: {
                mode: typeof ui.mode === 'string' ? ui.mode : 'normal',
            },
        }),
    },
};
